import produce from 'immer';

import {
    GET_TEAM_DATA_REQUEST,
    GET_TEAM_DATA_SUCCESS,
    GET_TEAM_DATA_FAIL,
    GET_COST_REPORT_REQUEST,
    GET_COST_REPORT_SUCCESS,
    GET_COST_REPORT_FAIL,
    GET_MONTHLY_REPORT_REQUEST,
    GET_MONTHLY_REPORT_SUCCESS,
    GET_MONTHLY_REPORT_FAIL
} from "./constants";

export const initialState = {
    isLoading: false,
    datas: [],
    error: false,
    costReportData: [],
    isCostReportLoading: false,
    costReportError: null,
    monthlyReportData: [],
    isMonthlyReportLoading: false,
    monthlyReportError: null,
};

const newsReducer = (state = initialState, {type, payload}) =>
    produce(state, draft => {
        switch (type) {
            case GET_TEAM_DATA_REQUEST:
                draft.isLoading = true;
                draft.datas = [];
                draft.error = false;
                break;
            case GET_TEAM_DATA_SUCCESS:
                draft.isLoading = false;
                draft.datas = payload.users.map((e, i) => { return { ...e, key: i}});
                draft.attempts = payload.attempts.training_results;
                break;
            case GET_TEAM_DATA_FAIL:
                draft.isLoading = false;
                draft.error = payload;
                break;
            case GET_COST_REPORT_REQUEST:
                draft.isCostReportLoading = true;
                draft.costReportError = null;
                break;
            case GET_COST_REPORT_SUCCESS:
                draft.isCostReportLoading = false;
                draft.costReportData = payload;
                break;
            case GET_COST_REPORT_FAIL:
                draft.isCostReportLoading = false;
                draft.costReportError = payload;
                break;
            case GET_MONTHLY_REPORT_REQUEST:
                draft.isMonthlyReportLoading = true;
                draft.monthlyReportError = null;
                break;
            case GET_MONTHLY_REPORT_SUCCESS:
                draft.isMonthlyReportLoading = false;
                draft.monthlyReportData = payload;
                break;
            case GET_MONTHLY_REPORT_FAIL:
                draft.isMonthlyReportLoading = false;
                draft.monthlyReportError = payload;
                break;
            default:
                break;
        }
    });

export default newsReducer;